<script>
import Layout from '@layouts/main/main'
import i18n from '@src/i18n'

export default {
  page: {
    title: i18n.t('PAGE_TIMEOUT'),
    meta: [
      { name: 'description', content: 'The page timed out while loading.' },
    ],
  },
  components: { Layout },
}
</script>

<template>
  <Layout>
    <h1 :class="$style.title">
      The page timed out while loading. Are you sure you're still connected to
      the Internet?
    </h1>
  </Layout>
</template>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
